export default __webpack_public_path__ + "static/media/afis.ddb63075.jpg";